import {
  ReportSummaryConfigBase,
  SUMMARY_VALUE_TYPES,
} from "../../summary/types";

export const Summary: ReportSummaryConfigBase[] = [
  {
    label: "Unbilled Amount",
    fields: ["unbilled_amount"],
    type: [SUMMARY_VALUE_TYPES.Money],
  },
  {
    label: "Number Of Rows",
    fields: ["row_count"],
    type: [SUMMARY_VALUE_TYPES.Count],
  },
];
